import { render, staticRenderFns } from "./AddNewProduct.modal.vue?vue&type=template&id=63b27faf"
import script from "./AddNewProduct.modal.vue?vue&type=script&lang=ts"
export * from "./AddNewProduct.modal.vue?vue&type=script&lang=ts"
import style0 from "./AddNewProduct.modal.vue?vue&type=style&index=0&id=63b27faf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports